import Avatar from "../avatar/avatar";
import React from "react";
import { Player } from "../../../types";

type Props2 = {
  player: Player;
  onClick: (player: Player) => void;
  checked: boolean;
};
const ClickableAvatar = ({ player, onClick, checked }: Props2) => {
  function handleClick() {
    onClick(player);
  }

  return (
    <div
      onClick={handleClick}
      className={`cursor-pointer ${checked ? "bg-[#e21cff]" : ""}`}
    >
      <Avatar
        key={player.id}
        name={player.name}
        spriteId={player.meta.sprite_id}
        size="small"
        variant="basic"
      />
    </div>
  );
};

export default ClickableAvatar;
